export default "__VITE_ASSET__5b36e990__"